import Vue from 'vue'
import Router from 'vue-router'
import {
  Home, Fundamentals, Drive, Training, PolicyManualWizard, Surveys, JobDescriptionGenerator, LiveHrAdvice,
  TimeAttendance, Complete, Login, ForgotPassword, ForgotUsername, Consulting, Blog, BlogPost, AboutUs, HrDonates,
  Careers, ContactUs, RequestDemo, MediaArticles, MediaPost, BecomePartner, TermsOfUse, PrivacyPolicy,
  Security, Accessibility, Feedback, Page503, Page404, Maintenance, Oooops, Unsubscribe, HelloHr
} from '../components'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      seo: 'homepage'
    },
    {
      path: '/manulife',
      name: 'Manulife',
      beforeEnter () { location.href = 'https://app.hrdownloads.com/manulife' }
    },
    {
      path: '/timhortons',
      name: 'TimHortons',
      beforeEnter () { location.href = 'https://legacy.hrdownloads.com/timhortons' }
    },
    {
      path: '/timhortons/*',
      name: 'TimHortons',
      beforeEnter () { location.href = 'https://legacy.hrdownloads.com/timhortons' }
    },
    {
      path: '/platform',
      name: 'Platform Logins',
      beforeEnter () { location.href = 'https://legacy.hrdownloads.com/platform/login' }
    },
    {
      path: '/platform/*',
      name: 'Platform Logins',
      beforeEnter () { location.href = 'https://legacy.hrdownloads.com/platform/login' }
    },
    {
      path: '/forgot-password',
      name: 'Platform Logins',
      beforeEnter () { location.href = 'https://legacy.hrdownloads.com/forgot-password/' }
    },
    {
      path: '/forgot-username',
      name: 'Platform Logins',
      beforeEnter () { location.href = 'https://legacy.hrdownloads.com/forgot-username/' }
    },
    {
      path: '/employee/login',
      name: 'Employee Login',
      beforeEnter () { location.href = 'https://legacy.hrdownloads.com/employee/login' }
    },
    {
      path: '/login',
      name: 'Login',
      groups: { headerNav: 8 },
      component: Login,
      beforeEnter () { location.href = 'https://app.hrdownloads.com/login' }
    },
    {
      path: '/product/time-attendance',
      name: 'TimeAttendance',
      beforeEnter () { location.href = '/product/complete' }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/forgot-username',
      name: 'ForgotUsername',
      component: ForgotUsername
    },
    {
      path: '/404',
      name: 'Page404',
      component: Page404
    },
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: Unsubscribe
    },
    {
      path: '/503',
      name: 'Page503',
      component: Page503
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: '/oooops',
      name: 'Oooops',
      component: Oooops
    },
    {
      path: '/product',
      name: 'Product',
      redirect: '/',
      groups: { headerNav: 1 },
      component: { template: '<router-view/>' },
      children: [
        {
          path: 'fundamentals',
          name: 'Fundamentals',
          groups: { firstLevel: 1 },
          props: true,
          component: Fundamentals,
          seo: 'hr-fundamentals'
        },
        {
          path: 'drive',
          name: 'Drive',
          groups: { firstLevel: 2 },
          component: Drive,
          seo: 'hr-drive'
        },
        {
          path: 'training',
          name: 'Training',
          groups: { addOn: 1 },
          component: Training
        },
        {
          path: 'policy-manual-wizard',
          name: 'PolicyManualWizard',
          groups: { addOn: 2 },
          component: PolicyManualWizard
        },
        {
          path: 'surveys',
          name: 'Surveys',
          groups: { addOn: 3 },
          component: Surveys,
          seo: 'surveys-and-forms'
        },
        {
          path: 'job-description-generator',
          name: 'JobDescriptionGenerator',
          groups: { addOn: 4 },
          component: JobDescriptionGenerator
        },
        {
          path: 'live-hr-advice',
          name: 'LiveHrAdvice',
          groups: { addOn: 5 },
          component: LiveHrAdvice
        },
        {
          path: 'time-attendance',
          name: 'TimeAttendance',
          groups: { commingSoon: 1 },
          component: TimeAttendance,
          seo: 'time-and-attendance'
        },
        {
          path: 'complete',
          name: 'Complete',
          groups: { allInOne: 1 },
          component: Complete,
          seo: 'hr-complete'
        }
      ]
    },
    {
      path: '/consulting',
      name: 'Consulting',
      groups: { headerNav: 2, hide: 1 },
      component: Consulting
    },
    {
      path: '/blog',
      name: 'Blog',
      groups: { headerNav: 3, resources: 1, hide: 1 },
      component: Blog
    },
    {
      path: '/blog/article/:id',
      name: 'BlogPost',
      component: BlogPost
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      groups: { headerNav: 4, company: 1 },
      component: AboutUs
    },
    {
      path: '/hrdonates',
      name: 'HrDonates',
      groups: { headerNav: 5, hide: 1 },
      component: HrDonates,
      seo: 'hr-donates'
    },
    {
      path: '/careers',
      name: 'Careers',
      groups: { headerNav: 6, company: 2 },
      component: Careers
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      groups: { headerNav: 7, resources: 1 },
      component: ContactUs
    },
    {
      path: '/request-a-demo',
      name: 'RequestDemo',
      component: RequestDemo,
      seo: 'request-demo'
    },
    {
      path: '/media-articles',
      name: 'MediaArticles',
      groups: { company: 3 },
      component: MediaArticles
    },
    {
      path: '/media-articles/:id',
      name: 'MediaPost',
      component: MediaPost
    },
    {
      path: '/become-a-partner',
      name: 'BecomePartner',
      groups: { resources: 2 },
      component: BecomePartner
    },
    {
      path: '/terms-of-use',
      name: 'TermsOfUse',
      groups: { footerNav: 1 },
      component: TermsOfUse
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      groups: { footerNav: 2 },
      component: PrivacyPolicy
    },
    {
      path: '/security',
      name: 'Security',
      groups: { footerNav: 3 },
      component: Security
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      groups: { footerNav: 4 },
      component: Accessibility
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: Feedback
    },
    {
      path: '/hellohr',
      name: 'hellohr',
      component: HelloHr,
      seo: 'hello-hr'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js